import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m16.5 11.5 1.5-2 1.5 2h-3Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M12 18.5v-10m-4 0h4m4 0h-4m0 0v-2m6 4.5a6 6 0 0 1-12 0" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "m4.5 11.5 1.5-2 1.5 2h-3ZM13.5 18.5l-1.5 2-1.5-2h3Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", { d: "M13.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" }, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }